module.exports = __webpack_public_path__ + "static/media/edek6.ec7c5ac9.png";